module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-tabs', {
    attrs: {
      "type": "is-boxed"
    },
    on: {
      "change": function($event) {
        return _vm.deleteTab()
      }
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('b-tab-item', {
    attrs: {
      "label": "Create New User"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-three-quarters"
  }, [_c('p', [_vm._v("Please fill out the form to create a new user.")]), _vm._v(" "), _c('section', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "First Name"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "First Name",
      "type": "text"
    },
    model: {
      value: (_vm.user.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "first_name", $$v)
      },
      expression: "user.first_name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Last Name"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Last Name",
      "type": "text"
    },
    model: {
      value: (_vm.user.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "last_name", $$v)
      },
      expression: "user.last_name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "value": "",
      "password-reveal": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Photo URL"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "photo_url",
      "type": "url"
    },
    model: {
      value: (_vm.user.photo_url),
      callback: function($$v) {
        _vm.$set(_vm.user, "photo_url", $$v)
      },
      expression: "user.photo_url"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Google Sheet URL"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Google Spread Sheet URL",
      "type": "url"
    },
    model: {
      value: (_vm.user.sheet_url),
      callback: function($$v) {
        _vm.$set(_vm.user, "sheet_url", $$v)
      },
      expression: "user.sheet_url"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary is-medium ",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.signUp()
      }
    }
  }, [_vm._v("Submit")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Update User"
    }
  }), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Detele User"
    }
  }, [(_vm.activeTab === 2) ? _c('delete-user-tab') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea3aebca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client_portal/ManageUsers.vue
// module id = 523
// module chunks = 1